<section
  #contentEl
  class="modal custom--modal modal--panel"
  role="dialog"
  aria-modal="true"
  aria-label="Add Edit Modal"
  @slideRight
>
  @switch (viewType) {
    <!-- SUCCESS VIEW -->
    @case ('success') {
      <header
        class="modal__header"
        data-test-id="addEditModalHeaderSuccessCase"
      >
        <p
          class="t-data t-bold"
          data-test-id="addEditModalHeaderSuccessMessage"
        >
          {{ config?.messages?.success }}
        </p>
      </header>
      <section class="modal__body" data-test-id="addEditModalSuccessBody">
        <div
          class="modal__message"
          data-test-id="addEditModalSuccessMessageWrapper"
        >
          <h4 class="t-bold" data-test-id="addEditModalSuccessId">
            ID # {{ successResponse?.id }}
          </h4>
          <p class="t-data t-bold" data-test-id="addEditModalSuccessMessage">
            {{ config?.messages?.success }}
          </p>
        </div>
        <div class="model-attributes">
          @for (
            attribute of attributes.attributes;
            track attribute;
            let i = $index
          ) {
            @if (attribute?.title) {
              <h6
                class="add-row-attribute__title t-bold"
                [attr.data-test-id]="'addEditModalModelAttributeTitle_' + i"
              >
                {{ attribute.title }}
              </h6>
            } @else {
              <model-attribute
                [attr.direction]="
                  attribute?.direction ? attribute?.direction : null
                "
                [config]="attribute"
                [context]="successResponse"
                [attr.data-test-id]="'addEditModalModelAttribute_' + i"
              >
              </model-attribute>
            }
          }
        </div>
      </section>
      <footer class="modal__footer" data-test-id="addEditModalSuccessFooter">
        <zip-button
          data-test-id="addEditModalSuccessFooterExitButton"
          level="low"
          content="Exit"
          (click)="onCancel()"
        >
        </zip-button>
        @if (viewProfile) {
          <zip-button
            data-test-id="addEditModalSuccessFooterViewProfileButton"
            level="high"
            content="View Profile"
            (click)="onContinue()"
          >
          </zip-button>
        }
      </footer>
    }
    <!-- ERROR VIEW -->
    @case ('error') {
      <header class="modal__header" data-test-id="addEditModalHeaderErrorCase">
        <p class="t-data t-bold" data-test-id="addEditModalHeaderErrorMessage">
          {{ config?.messages?.error }}
        </p>
      </header>
      <section class="modal__body" data-test-id="addEditModalErrorBody">
        <div
          class="modal__message"
          data-test-id="addEditModalErrorMessageWrapper"
        >
          <h4 class="t-bold" data-test-id="addEditModalErrorMessage">
            There was an error processing your request.
          </h4>
        </div>
        <div class="t-bold error__message">
          @if (emailError) {
            <h6 data-test-id="addEditModalEmailErrorMessage">
              Email {{ emailError[0] | slice: 5 }}
            </h6>
          }
          @if (phoneError) {
            <h6 data-test-id="addEditModalPhoneErrorMessage">
              PhoneNumber {{ phoneError[0] | slice: 5 }}
            </h6>
          }
        </div>
      </section>
      <footer class="modal__footer" data-test-id="addEditModalErrorFooter">
        <zip-button
          data-test-id="addEditModalErrorFooterExitButton"
          level="low"
          content="Exit"
          (click)="onCancel()"
        ></zip-button>
        <zip-button
          data-test-id="addEditModalErrorFooterTryAgainButton"
          level="high"
          content="Try Again"
          (click)="onRetry()"
        ></zip-button>
      </footer>
    }
    <!-- Existing CLIENTS DATA VIEW -->
    @case ('existingClientList') {
      <existing-client-list-modal
        [config]="config"
        [existingClientsData]="existingClientsData"
        [isSaveButtonDisabled]="isSaveButtonDisabled"
        (cancel)="onCancel()"
        (save)="onSave($event)"
        (continue)="onContinue($event)"
        data-test-id="addEditModalExistingClientListModal"
      >
      </existing-client-list-modal>
    }
    <!-- FORM VIEW IS DEFAULT -->
    @default {
      <header
        class="modal__header"
        data-test-id="addEditModalHeaderDefaultCase"
      >
        <p class="t-data t-bold" data-test-id="addEditModalDefaultHeaderTitle">
          {{ config.header }}
        </p>
      </header>
      <section class="modal__body" data-test-id="addEditModalDefaultBody">
        @for (group of config.form.groups; track group; let i = $index) {
          <div class="form-group">
            <header
              class="form-group__header"
              [attr.data-test-id]="'addEditModalFormGroupHeader_' + i"
            >
              <h2
                class="h6 t-bold title"
                [attr.data-test-id]="'addEditModalFormGroupTitle_' + i"
              >
                {{ group.header }}
              </h2>
            </header>
            <form-group
              #countyFormGroup
              [attr.data-test-id]="'addEditModalFormGroup_' + i"
              [configs]="group.controls"
              [form]="addRowForm"
            ></form-group>
          </div>
        }
      </section>
      <footer class="modal__footer" data-test-id="addEditModalDefaultFooter">
        <zip-button
          data-test-id="addEditModalDefaultFooterCancelButton"
          level="low"
          content="Cancel"
          [disabled]="isModalOpen"
          (modalConfirm)="onCancel()"
          (modalOpen)="isModalOpen = $event"
          [triggerConfirmationModal]="config.cancelConfirm"
        >
        </zip-button>
        <zip-button
          data-test-id="addEditModalDefaultFooterSaveButton"
          level="high"
          [disabled]="!addRowForm.valid || isModalOpen || isNextDisabled"
          [content]="config.save"
          (zipButtonClicked)="onSave()"
        >
        </zip-button>
      </footer>
    }
  }
</section>
